/**
 * Returns the indexed by one field collection
 * @param {any[]} arr - array to be converted into the indexed collection
 * @param {string|symbol} fieldName - filed name for indexing
 * @param {object} mixin - object to be mixed to every object in collection
 * @returns {any}
 */
export function getIndexedCollection (arr, fieldName = 'id', mixin = {}) {
  return arr.reduce((acc, el) => ({ ...acc, [el[fieldName]]: { ...el, ...mixin } }), {})
}

/**
 * Returns the indexed by one field collection
 * @param {any[]} arr - array to be converted into the indexed collection
 * @param {string|symbol} fieldName - filed name for indexing
 * @returns {any}
 */
export function getIndexedCollectionSimple (arr, fieldName = 'id') {
  return arr.reduce((acc, el) => ({ ...acc, [el[fieldName]]: el }), {})
}

/**
 * Converts date string from server and returns proper Date object
 * @param {string} dt - date in format YYYY-MM-DDThh:mm:ss.xxxxx
 */
export function formDate (dt) {
  const parsed = dt.replace('Z', '') // .split('T')
  const date = new Date(parsed)
  // const time = parsed[1].split(':')
  // const seconds = time[2].split('.')
  // time[2] = +seconds[0]
  // time[0] = +time[0]
  // time[1] = +time[1]
  // if (seconds[1]) {
  //   time.push(+(seconds[1].slice(0, 3)))
  // }
  // date.setHours(...time)

  return date
}

/**
 * Returns human-friendly date string
 * @param {string} dt - date in format YYYY-MM-DDThh:mm:ss.xxxxx
 * @param {string=} timeZone - time zone
 */
export function dateTimeToHoursMinutes (dt, timeZone) {
  return (new Date(dt)).toLocaleString('ru-RU', { hour: '2-digit', minute: '2-digit' })
}

export function isElectron () {
  // Renderer process
  if (typeof window !== 'undefined' && typeof window.process === 'object' && window.process.type === 'renderer') {
    return true
  }

  // Main process
  if (typeof process !== 'undefined' && typeof process.versions === 'object' && !!process.versions.electron) {
    return true
  }

  // Detect the user agent when the `nodeIntegration` option is set to true
  if (typeof navigator === 'object' && typeof navigator.userAgent === 'string' && navigator.userAgent.indexOf('Electron') >= 0) {
    return true
  }

  return false
}
